import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import { mutationAddTemplateList } from "Apollo";
import { ShowNotice } from "Store";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import InputRowRaw from "module-common/InputRow";
import Icon from "module-common/Icon";
import index from "antd/lib/breadcrumb";

export default compose(
  graphql(mutationAddTemplateList, {
    name: "mutationAdd"
  })
)(
  observer(
    class AddTemplateModals extends Component {
      static propTypes = {
        text: PropTypes.string,
        onCancel: PropTypes.func,
        onConfirm: PropTypes.func
      };
      state = {
        title: "",
        template: "",
        arrOfTemplate: []
      };

      handleChange(text) {
        this.setState({
          template: text
        });
      }

      handleAddStream() {
        const { template, arrOfTemplate } = this.state;
        arrOfTemplate.push(template);
        this.setState({
          template: ""
        });
      }

      handleDelStream(template) {
        const { arrOfTemplate } = this.state;
        for (let i = 0; i < arrOfTemplate.length; i++) {
          if (arrOfTemplate[i] == template) {
            delete arrOfTemplate[i];
          }
        }
        this.setState({
          arrOfTemplate: arrOfTemplate
        });
      }

      render() {
        const { text, onCancel, onConfirm } = this.props;
        const { loading, title, template, arrOfTemplate } = this.state;

        const viewTemplate = arrOfTemplate.map((template, index) => {
          return (
            <Stream key={index}>
              <StreamWord>
                {template.split("\n").map((item, key) => {
                  return (
                    <span key={key}>
                      {item}
                      <br />
                    </span>
                  );
                })}
              </StreamWord>
              <Icon
                name="minus"
                width={17}
                height={17}
                onClick={this.handleDelStream.bind(this, template)}
              />
            </Stream>
          );
        });

        return (
          <Modal>
            <Wrapper>
              <Scrollbars>
                <Text>{text}</Text>
                <Title> Template info </Title>
                <InputRow
                  label="Template Title "
                  inputWidth={500}
                  value={title}
                  onChange={text => {
                    this.setState({
                      title: text
                    });
                  }}
                />
                <Row>
                  <InputRow
                    type="textarea"
                    label="Template Reply"
                    inputWidth={300}
                    value={template}
                    onChange={text => this.handleChange(text)}
                  />
                  <Icon
                    name="plus"
                    width={25}
                    height={27}
                    onClick={() => this.handleAddStream()}
                  />
                </Row>

                {viewTemplate}

                <Buttons>
                  <Button
                    width={100}
                    onClick={onCancel}
                    color="gray"
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                  <Button
                    width={170}
                    onClick={this.onConfirm}
                    loading={loading}
                    disabled={loading}
                  >
                    Add Template
                  </Button>
                </Buttons>
              </Scrollbars>
            </Wrapper>
          </Modal>
        );
      }

      onConfirm = async () => {
        const { onConfirm, mutationAdd } = this.props;
        const { title, arrOfTemplate } = this.state;

        const TemplateReplyInput = [];
        const len = arrOfTemplate.length;
        for (let i = 0; i < len; i++) {
          if (arrOfTemplate[i] !== undefined) {
            TemplateReplyInput.push({
              content: arrOfTemplate[i]
            });
          }
        }
        if (onConfirm) {
          if (title) {
            this.setState({
              loading: true
            });
            try {
              await mutationAdd({
                variables: {
                  TemplateListInput: {
                    content: title
                  },
                  TemplateReplyInput: TemplateReplyInput
                },
                refetchQueries: ["getTemplateList"]
              });
              onConfirm();
              ShowNotice("template-reply-add-success");
            } catch (e) {
              ShowNotice("template-reply-add-error");
            }
            this.setState({
              loading: false
            });
          } else {
            ShowNotice("template-reply-incomplete-field-error");
          }
        }
      };
    }
  )
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 300px;
`;

const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 10px;
`;

const Buttons = styled.div`
  margin-top: 50px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;

const Title = styled.div`
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const InputRow = styled(InputRowRaw)`
  margin-bottom: 10px;
  margin-right: 0;
`;

const Row = styled.div`
  display: flex;
`;

const Stream = styled.div`
  display: flex;
  background: #e8e8e8;
  padding: 10px;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 8px;
  justify-content: space-between;
`;

const StreamWord = styled.span``;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/template-reply/AddTemplateModals.js